export default {"src":"/_next/static/media/PFlag.3106a05f.svg","height":24,"width":32};